import { RouterModule , Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';

const appRoutes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'dashboard',
    loadChildren: 'app/dashboard/dashboard.module#DashboardModule',
    data: { preload: true }
  },
];

export const routing = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/app.routing.ts